import { Component } from '@angular/core';

@Component({
  selector: 'app-recovery-pass',
  templateUrl: './recovery-pass.component.html',
  styleUrls: ['./recovery-pass.component.css']
})
export class RecoveryPassComponent {

  currentPassword: string = '';
  newPassword: string = '';
  repeatPassword: string = '';

  showPass(show, id) {
    const tipo = document.getElementById(id);
    if (show == true) {
      tipo.setAttribute('type', 'text');
    } else {
      tipo.setAttribute('type', 'password');
    }
  }
}